import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useEvent() {
  return useQuery({
    queryKey: ["event"],
    queryFn: async () => (await api.get("/event")).data,
  });
}

export function useAnnouncements() {
  return useQuery({
    queryKey: ["announcements"],
    queryFn: async () => (await api.get("/announcements")).data,
  });
}
